module.exports = __webpack_public_path__ + "static/media/IMG_0798.8c061bbc.jpg";